import { connect } from 'react-redux';
import { compose, withHandlers } from 'recompose';
import { ChurnZeroService, RUN_SETTLEMENT_REPORT } from '../../../../modules/infra/observability/churnzero';
import withNewDesignStyles from '../../../common/hoc/withNewDesignStyles';
import { downloadSettlementReportPdf } from '../actions';
import { getFiltersForMetrics } from '../metrics/selectors';

const SettlementReportContainer = compose(
  withNewDesignStyles,
  connect(
    state => ({
      filters: getFiltersForMetrics(state),
    })
  ),
  withHandlers({
    downloadPdf: props => () => {
      downloadSettlementReportPdf({
        fromDate: props.filters.fromDate,
        toDate: props.filters.toDate,
        shopId: props.filters.shopId,
        brandId: props.filters.brandId,
        shopFilter: props.filters.shopFilter,
      });
      ChurnZeroService.track(RUN_SETTLEMENT_REPORT);
    },
  }),
);

export default SettlementReportContainer;
